import { mapConfig } from "./Config";
import { CustomPoint } from "./CustomPoint";

export class GetLocationControl {
    _map;
    _container;
    hbdmap;
    locationHTML =
        '<button class="mapboxgl-ctrl-icon mapboxgl-ctrl-location" type="button" title="Mein Standort" aria-label="Mein Standort"></button>';

    constructor(hbdmap) {
        this.hbdmap = hbdmap;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement("div");
        this._container.className =
            "mapboxgl-ctrl mapboxgl-ctrl-group toGroup d-block";
        this._container.innerHTML = this.locationHTML;
        this._container.addEventListener("click", () => {
            this.getLocation();
        });
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }

    getLocation() {
        let coords = [];

        if (this.hbdmap.myLocation) {
            this.hbdmap.flyMeTo(
                this.hbdmap.myLocation.geometry.coordinates,
                null,
                5,
                mapConfig[this.hbdmap.type].zoom
            );
        } else {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        coords = [
                            position.coords.longitude,
                            position.coords.latitude,
                        ];

                        this.hbdmap.myLocation = new CustomPoint()
                            .setId("MyLocation")
                            .setName("Mein Standort")
                            .setCoordinates(coords)
                            .build();

                        if (!this.hbdmap.checkPredefinedPoints()) {
                            this.hbdmap.setPin(
                                "location",
                                this.hbdmap.myLocation,
                                false
                            );
                            this.hbdmap.flyMeTo(
                                coords,
                                null,
                                5,
                                mapConfig[this.hbdmap.type].zoom
                            );
                        }

                        if (
                            typeof this.hbdmap.checkRouteComplete === "function"
                        ) {
                            // route-section, not yp/wp-section
                            this.hbdmap.checkRouteComplete();
                        }
                    },
                    (error) => {
                        console.log(error.message);
                        $(".mapboxgl-ctrl-location").parent().remove();
                        this.hbdmap.checkPredefinedPoints();
                    }
                );
            } else {
                console.log("Geolocation is not supported by this browser.");
                $(".mapboxgl-ctrl-location").parent().remove();
                this.hbdmap.checkPredefinedPoints();
            }
        }
    }
}